import { render, staticRenderFns } from "./MarketMarket.vue?vue&type=template&id=60121f46&scoped=true"
import script from "./MarketMarket.vue?vue&type=script&lang=js"
export * from "./MarketMarket.vue?vue&type=script&lang=js"
import style0 from "./MarketMarket.vue?vue&type=style&index=0&id=60121f46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60121f46",
  null
  
)

export default component.exports